/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { styled } from '@mui/material/styles';
import { Slide } from 'pure-react-carousel';

export const CarouselSlide = styled(Slide)({});
